<template>
  <div class="mask personInfo" id="personInfo">
    <el-form :model="userForm" :rules="rules" ref="ruleForm" label-width="100px">
      <p class="title">账号设置</p>
      <div class="scroll">
        <div class="avatar" >
          <svg class="icon profile" aria-hidden="true" v-show="userForm.avatar.length==0">
            <use xlink:href="#icon_profile_normal"></use>
          </svg>
          <el-image :src="userForm.avatar"  v-show="userForm.avatar.length!=0"></el-image>
          <svg class="icon maskicon" aria-hidden="true" >
            <use xlink:href="#icon_mask"></use>
          </svg>
          <input type="file" class="uploadFile" title="上传头像" placeholder="上传头像" @change="fileChangeHead" accept="image/png,image/bmp,image/jpg">
        </div>
        <el-form-item label="昵称:" prop="nickname">
          <!-- {{userForm.nickname}} -->
          <el-input type="text" v-model="userForm.nickname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password">
          <el-input  :type="showPassword?'text':'password'" v-model="userForm.password" autocomplete="off" ></el-input>
          <span class="showPassword" @click="isPswShow">
            <svg class="icon closeEyes" aria-hidden="true" v-show="!showPassword">
              <use xlink:href="#icon_invisible_normal"></use>
            </svg>
            <svg class="icon showEyes" aria-hidden="true" v-show="showPassword">
              <use xlink:href="#icon_visible_normal"></use>
            </svg>
          </span>
        </el-form-item>
        <div class="showUserInfo attachfile">
          <label>电子签名：</label>
          <el-image :src="userForm.attachfile" v-if="userForm.attachfile"></el-image>
          <div class="imgBefore" v-else>请上传电子签名</div>

          <span class="btn btn-add">上传<input type="file" class="uploadFile" @change="fileChange" accept="image/png,image/bmp,image/jpg"></span>
        </div>
        <p class="showUserInfo"><label>用户名：</label><span>{{userInfo.username}}</span></p>
        <p class="showUserInfo"><label>姓名：</label><span>{{userInfo.true_name}}</span></p>
        <p class="showUserInfo"><label>部门岗位：</label><span>{{userInfo.department}}-{{userInfo.second_depart}}-{{userInfo.job}}</span></p>
        <p class="showUserInfo"><label>邮箱：</label>{{userInfo.email}}<span></span></p>
        <p class="showUserInfo"><label>电话号码：</label><span>{{userInfo.phone}}</span></p>
        <p class="showUserInfo"><label>品牌名称：</label><span>{{userInfo.brand_name}}</span></p>
        <p class="showUserInfo"><label>二级站点：</label><span>{{userInfo.second_site}}</span></p>
        <p class="secTitle">角色详情</p>
        <p class="showUserInfo" v-for="(item,index) in userInfo.system" :key="index"><label>{{item.system_name}}：</label><span>{{item.group_name}}</span></p>
      </div>
      <div class="btnForm">
        <span class="button btn-add" @click="submitForm()"> 确定</span>
        <span class="button" @click="cancle()">取消</span>
      </div>
    </el-form>
   
  </div>
</template>

<script>
import {infoGet,infoEdit} from '../../api/user'
import { uploadBase64 } from '../../api/login'
import {setApiUrl} from '../../utils/index'
import {mapMutations} from 'vuex'

export default {
  data(){
    return{
      userForm:{
        nickname:'',
        password:'',
        avatar:'',
        attachfile:""
      },
      rules:{
        nickname:[{required: true, message: '请输入昵称', trigger: 'blur'}],
        password:[{pattern:/^[^\s]{8,16}$/, message: '密码只能填写8-16位数字、英文字母、标点符号！', trigger: 'change'}]
      },
      userInfo:{},
      domain:"",
      showPassword:false,
    }
  },
  created(){
    this.getInfo()
    this.domain = setApiUrl()
  },
  methods:{
    isPswShow(){
      this.showPassword = !this.showPassword
    },
    cancle(){
      this.$emit('isShowPersonInfo')
    },
    submitForm(){
      this.editInfo()
    },
    editInfo(){
      if(!this.userForm.password){
        delete this.userForm.password
      }
      infoEdit(this.userForm).then(res=>{
        this.setUserinfo(res)
        this.$message({message:'编辑个人信息成功',type:'success'})
        this.cancle()
      })
    },
    getInfo(){
      infoGet().then(res=>{
        this.userInfo = res
        this.userForm.nickname = res.nickname
        this.userForm.attachfile = res.attachfile
        this.userForm.avatar  = res.avatar
      })
    },
    fileChange(event){
      let that = this
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
          this.fileName = '';
          return;
      }
      let params = {
        img_data:"",
        type:"attachfile"
      };
      var reader = new FileReader();
      reader.onload = (function (file) {
          return function (event) {
            params.img_data = this.result
            uploadBase64(params).then(res=>{
              that.$set( that.userForm,'attachfile',res.filePathNameHttp)
            })
          };
      })(files[0]);
      reader.readAsDataURL(files[0])      
    },
    ...mapMutations({
      setUserinfo: 'SET_USERINFO',
    }),
    fileChangeHead(event){
      let that = this
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
          this.fileName = '';
          return;
      }
      let params = {
        img_data:"",
        type:"head"
      };
      var reader = new FileReader();
      reader.onload = (function (file) {
          return function (event) {
            params.img_data = this.result
            uploadBase64(params).then(res=>{
              that.$set( that.userForm,'avatar',res.filePathNameHttp)
            })
          };
      })(files[0]);
      reader.readAsDataURL(files[0])      
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/maskForm.scss';

#personInfo{
  .scroll{
    max-height:374px ;
    overflow-y: auto;
    margin-right: 16px;
     //滚动条的宽度
    &::-webkit-scrollbar {
      width: 8px;
      height: 10px;
    }
    //滚动条的滑块
    &::-webkit-scrollbar-thumb {
      background-color: #CCCCCC;
      border-radius: 6px;
    }
    >div:not(.avatar),
    >p:not(.secTitle){
      padding-left: 80px;
      position: relative;
    }
    >p.secTitle{
      padding-left: 40px;
      position: relative;
    }
  }
 .avatar{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin: 0px auto 24px;
    position: relative;
    overflow: hidden;
    >img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .maskicon{
      display: none;
      position: absolute;
      top: 0;
      left: 0;
    }
    &:hover{
      .profile{
        display: none;
      }
      .maskicon{
        display: block;
      }
    }
}


.el-form{
    width: 32%;
    margin: 0 auto;
    // padding: 1.2% 3% 48px 3%;
    .title{
      position: relative;
      left: 6.5%;
      margin-top: 6.5%;
    }
    /deep/.el-form-item__label{
      text-align: right;
    }
    /deep/.el-input__inner{
      height: 36px;
      line-height: 36px;
    }
    .btnForm{
      margin-top: 42px;
      text-align: center;
      white-space: nowrap;
      margin-top: 58px;
      padding-bottom: 7.85%;
    }
    .el-input{
      min-width: 250px;
      max-width: 360px;
    }
    .el-form-item{margin-right: 0;}
    .secTitle{
      font-size: 14px;
      // font-family: 'SC-Bold';
       font-family:  Noto Sans SC;
      font-weight: 700;
      margin-bottom: 16px;
      margin-top: 9px;
    }
    .showUserInfo{
      font-size: 14px;
      margin-bottom: 15px;
      label{
        width: 100px;
        text-align: right;
        display: inline-block;
        height: 100%;
      
      }
      >.btn-add{
        width: calc(48% - 120px);
        max-width: 86px;
      }
    }
    .attachfile{
      height: 36px;
      line-height: 36px;
      display: flex;
      align-items: center;
      .el-image{
        width: 49%;
        min-width: auto;
        min-width: auto;
        height: 36px;
      }
      >div.imgBefore{
        width: 52%;
        min-width: auto;
        min-width: auto;
        height: 35px;
        border: 1px solid #CCC;
        border-radius: 5px;
        padding-left: 15px;
      }

    }
    .uploadFile{
      position: absolute;
      top: 0;
      left: 0%;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .showPassword{
      position: absolute;
      right: 70px;
      >.closeEyes{
        width: 22px;
        height: 12px;
      }
      >.showEyes{
        width: 22px;
        height: 16px;
      }
    }
  }
}


</style>